
























































































































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaTipoDocumento from "@/components/tipoDocumentos/Tabla.vue";
import FormularioTipoDocumento from "@/components/tipoDocumentos/Formulario.vue";
import { DataFormularioTipoDocumento } from "@/typings/components/tipoDocumentos/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoTipoDocumento from "@/components/tipoDocumentos/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  TipoDocumento,
  TipoDocumentos,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/tipoDocumentos";
import CargarTipoDocumentosExcel from "@/components/excel/CargarTipoDocumentos.vue";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";
//import { DataFormularioRegion } from "@/typings/components/regiones/formulario";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["tipoDocumentos"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getTipoDocumentos: "tipoDocumentos/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",

    getRutasUsuario: "usuario/getRutas",
    getArrayTipoDocumentos: "tipoDocumentos/getArray",
  }),
  methods: mapActions({
    setTipoDocumento: "tipoDocumentos/set",
    deleteTipoDocumento: "tipoDocumentos/delete",
    insertBatchTipoDocumentos: "tipoDocumentos/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaTipoDocumento,
    FormularioTipoDocumento,
    InfoTipoDocumento,
    MensajeEliminar,
    CargarTipoDocumentosExcel,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
  },
})
export default class VistaBancos extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  tipoDocumento: TipoDocumento | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTE BANCO?";
  dialogoCargarExcel = false;

  get tipoDocumentos(): TipoDocumentos {
    return this.getTipoDocumentos;
  }

  get items(): Array<TipoDocumento> {
    return this.getArrayTipoDocumentos;
  }

  get columnasExportacionTipoDocumentos(): Array<{ label: string; field: string }> {
    return [
      { label: "Nombre", field: "nombre" },
      { label: "Posición", field: "posicion" },
    ];
  }

  clickItem(val: { id: string } | null): void {
    this.tipoDocumento = val ? this.tipoDocumentos[val.id] : null;
  }

  clickPlus(): void {
    this.tipoDocumento = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioTipoDocumento): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setTipoDocumento(doc);
    if (doc.id != this.tipoDocumento?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Tipo Documento creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.tipoDocumento?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Tipo Documento editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.tipoDocumento = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const tipoDocumento = this.tipoDocumento;
    if (!tipoDocumento?.id) {
      console.error("error id: ", tipoDocumento);
      return;
    }
    this.deleteTipoDocumento(tipoDocumento.id);
    this.tipoDocumento = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(tipoDocumento: TipoDocumento): void {
    if (!tipoDocumento.id) {
      console.error("error id: ", tipoDocumento);
      return;
    }
    const doc = this.tipoDocumentos[tipoDocumento.id];
    if (doc) {
      this.tipoDocumento = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.tipoDocumento = null;
  }

  abrirDialogoFormulario(tipoDocumento: TipoDocumento): void {
    if (!tipoDocumento.id) {
      console.error("error id: ", tipoDocumento);
      return;
    }
    const doc = this.tipoDocumentos[tipoDocumento.id];
    if (doc) {
      this.tipoDocumento = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(tipoDocumento: TipoDocumento): void {
    if (!tipoDocumento.id) {
      console.error("error id: ", tipoDocumento);
      return;
    }
    const doc = this.tipoDocumentos[tipoDocumento.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.tipoDocumento = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.tipoDocumento = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.tipoDocumento = null;
  }
}
